import 'jquery';
import * as jcf from 'jcf';
import {EventEmitter} from 'events';
const PATH_BRAND_API = '/api/brand';
const PATH_MODEL_API = '/api/model';
const PATH_VERSION_API = '/api/version';

const SELECTOR_BRAND_SELECT = 'select[name="brand"]';
const SELECTOR_MODEL_SELECT = 'select[name="model"]';
const SELECTOR_VERSION_SELECT = 'select[name="version"]';
const FORM_HIDDEN_VERSION = 'input[name="repurchase[version]"]';

export default class RepurchaseForm extends EventEmitter {

    constructor(selectorForm) {
        super();
        this.selectorForm = selectorForm;
        this.isReady = false;
    }

    ready() {
        if (this.isReady) {
            return;
        }
        this.isReady = true;
        /** @type {Element|HTMLFormElement} */
        this.formDOM = document.querySelector(this.selectorForm);
        this.filterBrand();
        this.events();
    }

    events() {
        this.selectBrandElement.addEventListener('change', () => this.filterModel());
        this.selectModelElement.addEventListener('change', () => this.filterVersion());
        this.selectVersionElement.addEventListener('change', () => this.setVersionSelected());
        this.formDOM.addEventListener('submit', (e) => this.submitRepurchaseForm(e));
    }

    submitRepurchaseForm(e) {
        e.preventDefault();
        const formData = new FormData(this.formDOM);
        fetch(this.formDOM.action, {
            body: formData,
            method: 'POST'
        }).then(response => {
            response.json().then(reponse => {
                if (reponse.error) {
                    this.emit('error-saving', reponse.error);
                    this.showError(reponse.error);
                } else {
                    this.emit('success-save');
                }
            }).catch(result => {
                this.emit('error-saving', result);
            });
        }).catch(result => {
            this.emit('error-saving', result);
        });
    }

    showError(message) {
        /** @type {HTMLElement} */
        let errorDOM = this.formDOM.querySelector('.error-message');
        if (errorDOM) {
            errorDOM.querySelector('p').innerHTML = message.join('<br>');
            errorDOM.style.display = 'block';
        }
    }

    filterBrand() {
        fetch(PATH_BRAND_API)
            .then(response => {
                response.json().then(responseJson => {
                    this.renderOption(SELECTOR_BRAND_SELECT, responseJson, 'id', 'brand');
                });
            });
    }

    filterModel() {
        let selectedOptions = this.selectBrandElement.selectedOptions;
        this.resetSelect(SELECTOR_MODEL_SELECT);
        this.resetSelect(SELECTOR_VERSION_SELECT);
        if (selectedOptions.length > 0) {

            let searchParams = new URLSearchParams();
            searchParams.append('brand', selectedOptions[0].value);

            fetch(PATH_MODEL_API + '?' + searchParams.toString()).then(response => {
                response.json().then(responseJson => {
                    this.renderOption(SELECTOR_MODEL_SELECT, responseJson, 'id', 'model');
                });
            });
        }
    }

    filterVersion() {
        let selectedOptions = this.selectModelElement.selectedOptions;
        this.resetSelect(SELECTOR_VERSION_SELECT);

        if (selectedOptions.length > 0) {

            let searchParams = new URLSearchParams();
            searchParams.append('model', selectedOptions[0].value);

            fetch(PATH_VERSION_API + '?' + searchParams.toString()).then(response => {
                response.json().then(responseJson => {
                    this.renderOption(SELECTOR_VERSION_SELECT, responseJson, 'id', 'version');
                });
            });
        }
    }

    /**
     * @return {Element|HTMLSelectElement}
     */
    get selectBrandElement() {
        return this.formDOM.querySelector(SELECTOR_BRAND_SELECT);
    }

    /**
     * @return {Element|HTMLSelectElement}
     */
    get selectModelElement() {
        return this.formDOM.querySelector(SELECTOR_MODEL_SELECT);
    }

    /**
     * @return {Element|HTMLSelectElement}
     */
    get selectVersionElement() {
        return this.formDOM.querySelector(SELECTOR_VERSION_SELECT);
    }

    renderOption(selector, values, identifierValue, identifierLabel) {
        let selectDOM = this.formDOM.querySelector(selector);
        selectDOM.innerHTML = '';
        let optionsHTML = [];
        for (let value of values) {
            optionsHTML.push(`<option value="${value[identifierValue]}">${value[identifierLabel]}</option>`);
        }
        selectDOM.insertAdjacentHTML('beforeend', optionsHTML.join('\n'));
        // this.events();
        jcf.replace(selectDOM, 'Select');
        let instanceJcf = jcf.getInstance(selectDOM);
        if (instanceJcf) {
            instanceJcf.instance.showDropdown();
        }
    }

    resetSelect(selector) {
        let selectDOM = this.formDOM.querySelector(selector);
        selectDOM.innerHTML = '';
        jcf.replace(selectDOM, 'Select');

    }

    setVersionSelected() {
        let hidden = this.formDOM.querySelector(FORM_HIDDEN_VERSION);
        if (hidden) {
            hidden.value = this.selectVersionElement.value;
        }
    }
}
